import React from 'react';
import './SearchBar.css';

function SearchBar() {
  return (
    <div className="new-site-search-bar-root">
      <span className="new-site-search-bar-icon" aria-hidden="true" />
      <input
        type="search"
        aria-label="Döküman ara"
        className="new-site-search-bar-input"
        placeholder="Döküman ara"
      />
    </div>
  );
}

export default SearchBar;